import React, {useState, useEffect, memo} from "react";
import {Form, Button, Modal, Row, Col} from "react-bootstrap";
import {useForm} from "react-hook-form";
import Swal from "sweetalert2";
import axios from 'axios';

function UserForm({change, setChange, show, setShow, site}) {
    const {register, handleSubmit, reset} = useForm();
    const handleClose = () => {
        setShow(false);
        reset();
    };

    useEffect(() => {

        if (site) {
            reset(site);
        }


    }, [site, reset]);

    const onSubmit = async (data) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/site/${site ? `update/${site.siteId}` : `create`}`, data)
                .then(function (response) {
                    if (response.data.status === true) {
                        setChange(change + 1);
                        Swal.fire({
                            text: "İşlem başarıyla tamamlandı.",
                            icon: "success",
                            confirmButtonText: "Tamam",
                        });
                        handleClose();
                    } else {
                        console.log(response);
                        Swal.fire({
                            text: response.data.message,
                            icon: "error",
                            confirmButtonText: "Tamam",
                        });
                    }

                });
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <>
            <Modal show={show} size="small" onHide={handleClose} animation={false}>
                <Form className="d-flex flex-column h-100" onSubmit={handleSubmit(onSubmit)} method="POST">
                    <Modal.Header closeButton>
                        <Modal.Title
                            className="fs-5">{site == null ? "Site Ekle" : "Siteyi Güncelle"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Form.Group className="mb-3">
                            <Form.Label className="required">Site Adı</Form.Label>
                            <div className="d-flex">
                                <Form.Control type="text" maxLength={50} {...register("siteName")} required/>
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="required">Site Url</Form.Label>
                            <Form.Control type="text" maxLength={50} {...register("siteUrl")} required/>
                        </Form.Group>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Vazgeç
                        </Button>
                        <Button type="submit" variant="primary">
                            {!site ? "Kaydet" : "Güncelle"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default memo(UserForm);
